import React from 'react';
import { Box } from '@mui/system';

const Line = ({
  color,
  width = '100%',
  height
}: {
  color: string;
  width?: string;
  height: string;
}) => {
  return (
    <Box
      sx={{
        width,
        height,
        backgroundColor: color
      }}
    />
  );
};

export default Line;
